import { Component, Input, OnDestroy, OnInit,OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
// import { WebsoketService } from 'src/app/shared/services/websoket.service';
import { TypesenseService } from 'src/app/shared/services/typesense.service';

@Component({
    selector: 'app-fundamentals',
    templateUrl: './fundamentals.component.html',
    styleUrls: ['./fundamentals.component.scss'],
    standalone: false
})
export class FundamentalsComponent implements OnInit, OnDestroy,OnChanges {

  private subscriptions: Subscription[] = [];
  public data: any

  @Input() stock:any | undefined;
  @Input() fundamentals: any|undefined;

  @Input() etf:any | undefined;
  @Input() stockType : 'stock' | 'etf' = 'stock'
  @Input() currency: any


  constructor( private typesenseService: TypesenseService ) {
    typesenseService.dividendYieldData$.subscribe(data => this.data = data )
  }

  ngOnInit(): void {
   //  console.log("fundamentals",this.fundamentals);
   //  console.log(this.stock);

  }

  ngOnChanges(): void {
    try{
      if(this.fundamentals?.todaysPercent > 100){
        this.fundamentals.todaysPercent = 100
      }
      if(this.fundamentals?.fiftyTwoWeekPercent > 100){
        this.fundamentals.fiftyTwoWeekPercent = 100
      }
      if(this.fundamentals?.todaysPercent < 0){
        this.fundamentals.todaysPercent = 0
      }
      if(this.fundamentals?.fiftyTwoWeekPercent < 0){
        this.fundamentals.fiftyTwoWeekPercent = 0
      }
    }
    catch(e){

    }
  }


  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(item => {
        item.unsubscribe()
      })
    }
  }


}
